// @ts-nocheck
import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

import './Accordion.sass';

import Toggler from '../Buttons/Toggler';
import TypoContainer from '../TypoContainer';

interface Props {
	item: IAccordionItem;
	isTinyTitle: boolean;
	index: number;
	defaultOpen: boolean;
}

interface IAccordionItem {
	title: string;
	body: string;
	scrollID?: string;
}

const AccordionItem: React.FC<Props> = ({
	item,
	isTinyTitle,
	index,
	defaultOpen,
}) => {
	const [isOpened, setIsOpened] = useState<boolean>();

	const pageLocation = useLocation();
	const { pathname, hash: HASH } = pageLocation;
	const hash = HASH.substring(1);	


	useEffect(() => {
		defaultOpen ? setIsOpened(true) : setIsOpened(false);
	}, [defaultOpen]);

	const accordionItem = useRef<HTMLDivElement>();

	const calcHeightOnResize = () => {
		const node = accordionItem?.current;
		const content = node?.querySelector('.uikit-accordion__content');
		if (content.classList.contains('active')) {
			content.style.height = 'auto';
			const height = `${content.clientHeight}px`;
			content.style.height = height;
		}
	};

	useEffect(() => {
		window.addEventListener('resize', calcHeightOnResize);
		return () => {
			window.removeEventListener('resize', calcHeightOnResize);
		};
	}, []);

	useEffect(() => {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const node = accordionItem?.current;
		if (node.current !== null) {
			if (defaultOpen) {
				const content = node?.querySelector('.uikit-accordion__content');
				const height = `${content.clientHeight}px`;
				content.style.height = height;
			}
			node
				.querySelector('.uikit-accordion__heading')
				.addEventListener('click', () => {
					const content = node?.querySelector('.uikit-accordion__content');
					if (!content.classList.contains('active')) {
						content.classList.add('active');
						setIsOpened(true);
						content.style.height = 'auto';
						const height = `${content.clientHeight}px`;
						content.style.height = '0px';
						setTimeout(() => {
							content.style.height = height;
						}, 0);
					} else {
						console.log(321);
						content.style.height = '0px';
						content.addEventListener(
							'transitionend',
							() => {
								content.classList.remove('active');
								setIsOpened(false);
							},
							{
								once: true,
							}
						);
					}
				});
		}
	}, []);

	useEffect(() => {
		if (hash && item.scrollID && item.scrollID === hash) {
			window.scrollTo({
				behavior: 'smooth',
				top: accordionItem.current.offsetTop - 96,
			});
		}
	});
	return (
		<div ref={accordionItem} className={`uikit-accordion__item `}>
			<div className="uikit-accordion__heading">
				{pathname.includes('faq')
					? <Link
						to={`/faq#${item?.scrollID}`}
						className={`${
							isTinyTitle ? 'uikit-heading-tiny' : 'uikit-heading-lg'
						}`}
					>
						{item.title}
					</Link>
					: <h3
						className={`${
							isTinyTitle ? 'uikit-heading-tiny' : 'uikit-heading-lg'
						}`}
					>
						{item.title}
					</h3>
				}
				<Toggler
					className={`${isOpened ? 'uikit-button-toggler--active' : null}`}
				/>
			</div>
			{/* Add class .uikit-accordion__content--disabled to hide content */}
			<div
				className={`uikit-accordion__content${defaultOpen ? ' active' : ''}`}
			>
				<div className="uikit-accordion__content--inner">
					<TypoContainer markup={item.body} />
				</div>
			</div>
		</div>
	);
};

export default AccordionItem;
